"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Entity_1 = __importDefault(require("../../Core/Entity"));
var Version;
(function (Version) {
    Version["v1"] = "v1";
    Version["v2"] = "v2";
    Version["v3"] = "v3";
})(Version || (Version = {}));
var BaseRoute = '/billing-service';
var Routes = {
    GET_TASKS: "".concat(BaseRoute, "/").concat(Version.v1, "/tasks"),
    GET_AGGREGATED_TASKS: "".concat(BaseRoute, "/").concat(Version.v1, "/aggregated"),
    GET_ORDERS: "".concat(BaseRoute, "/").concat(Version.v2, "/billingData"),
    GET_AGGREGATED_TASKS_V2: "".concat(BaseRoute, "/").concat(Version.v2, "/billingData/aggregated"),
    GET_ORDERS_REPORT: "".concat(BaseRoute, "/").concat(Version.v2, "/billingData/report"),
    GET_AGGREGATED_TASKS_BY_DAYS: "".concat(BaseRoute, "/").concat(Version.v2, "/billingData/aggregatedByDays"),
    GET_REFUNDS: "".concat(BaseRoute, "/").concat(Version.v2, "/billingData/refunds"),
    GET_REFUNDS_REPORT: "".concat(BaseRoute, "/").concat(Version.v2, "/billingData/refunds/report"),
    GET_FLEETS: "".concat(BaseRoute, "/").concat(Version.v1, "/fleets"),
    GET_FLEETS_V3: "".concat(BaseRoute, "/").concat(Version.v3, "/fleets"),
    GET_TEAMS: "".concat(BaseRoute, "/").concat(Version.v1, "/teams"),
    GET_TEAMS_V3: "".concat(BaseRoute, "/").concat(Version.v3, "/teams"),
    POST_DISPUTE: "".concat(BaseRoute, "/").concat(Version.v1, "/dispute"),
    GET_DISPUTES_BY_TASK_IDS: "".concat(BaseRoute, "/").concat(Version.v1, "/dispute/getByTaskIds")
};
var BillingEntity = /** @class */ (function (_super) {
    __extends(BillingEntity, _super);
    function BillingEntity(session) {
        return _super.call(this, {
            session: session,
            entityName: 'billing-service'
        }) || this;
    }
    BillingEntity.prototype.getAllTasks = function (queryString) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator.get(Routes.GET_TASKS).withQueryString(queryString).invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    BillingEntity.prototype.getOrders = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator.post(Routes.GET_ORDERS).withPayload(payload).invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    BillingEntity.prototype.getAggregatedTasks = function (queryString) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator.get(Routes.GET_AGGREGATED_TASKS).withQueryString(queryString).invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    BillingEntity.prototype.getAggregatedTasksV2 = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator.post(Routes.GET_AGGREGATED_TASKS_V2).withPayload(payload).invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    BillingEntity.prototype.getOrdersReport = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator.post(Routes.GET_ORDERS_REPORT).withPayload(payload).invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    BillingEntity.prototype.getRefundsReport = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator.post(Routes.GET_REFUNDS_REPORT).withPayload(payload).invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    BillingEntity.prototype.getAggregatedByDaysTasksV2 = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator
                            .post(Routes.GET_AGGREGATED_TASKS_BY_DAYS)
                            .withPayload(payload)
                            .invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    BillingEntity.prototype.getRefunds = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator.post(Routes.GET_REFUNDS).withPayload(payload).invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    BillingEntity.prototype.getAllFleets = function (queryString) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator.get(Routes.GET_FLEETS).withQueryString(queryString).invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    BillingEntity.prototype.getAllFleetsV3 = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator.post(Routes.GET_FLEETS_V3).withPayload(payload).invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    BillingEntity.prototype.getAllTeams = function (queryString) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator.get(Routes.GET_TEAMS).withQueryString(queryString).invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    BillingEntity.prototype.getAllTeamsV3 = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator.post(Routes.GET_TEAMS_V3).withPayload(payload).invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    BillingEntity.prototype.postDispute = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator.post(Routes.POST_DISPUTE).withPayload(payload).invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    BillingEntity.prototype.getDisputesByTaskIds = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator.post(Routes.GET_DISPUTES_BY_TASK_IDS).withPayload(payload).invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return BillingEntity;
}(Entity_1.default));
exports.default = BillingEntity;
//# sourceMappingURL=BillingEntity.js.map